export default {"src":"/_next/static/media/Instagram.d180d433.svg","height":50,"width":49,"blurWidth":0,"blurHeight":0};